/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkflowGraph } from '../../models/workflow-graph';

export interface CaseTypesCaseTypeWorkflowGet$Params {
  caseType: string;
}

export function caseTypesCaseTypeWorkflowGet(http: HttpClient, rootUrl: string, params: CaseTypesCaseTypeWorkflowGet$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkflowGraph>> {
  const rb = new RequestBuilder(rootUrl, caseTypesCaseTypeWorkflowGet.PATH, 'get');
  if (params) {
    rb.path('caseType', params.caseType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkflowGraph>;
    })
  );
}

caseTypesCaseTypeWorkflowGet.PATH = '/case-types/{caseType}/workflow';
